import { cn } from '@/lib/utils';

interface SegmentOption<T extends string> {
  value: T;
  label: string;
}

interface SegmentControlProps<T extends string> {
  options: SegmentOption<T>[];
  value: T;
  onChange: (value: T) => void;
}

export function SegmentControl<T extends string>({ options, value, onChange }: SegmentControlProps<T>) {
  const idx = options.findIndex((o) => o.value === value);
  const widthPercent = 100 / options.length;

  return (
    <div className="relative grid h-11 rounded-2xl border border-border/40 bg-background/60 p-1" style={{ gridTemplateColumns: `repeat(${options.length}, 1fr)` }}>
      <span
        className="absolute bottom-1 left-1 top-1 rounded-[0.85rem] border border-border/40 bg-muted/30 transition-transform duration-300 ease-out"
        style={{ width: `calc(${widthPercent}% - 0.25rem)`, transform: `translateX(${idx * 100}%)` }}
      />
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          onClick={() => onChange(option.value)}
          className={cn(
            'relative z-10 rounded-xl px-3 text-xs font-semibold transition-colors',
            value === option.value ? 'text-primary' : 'text-muted-foreground hover:text-foreground',
          )}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
